import { create } from 'zustand';
import cacheHelper from '../helpers/cacheHelper';

const useAuth = create((set) => ({
  isLoggedIn: Boolean(cacheHelper.getToken()) || false,
  token: cacheHelper.getToken() || null,
  refreshToken: cacheHelper.getRefreshToken() || null,
  setAuthInfo: (token, refreshToken) => {
    if (token && refreshToken) {
      cacheHelper.setToken(token);
      cacheHelper.setRefreshToken(refreshToken);
      return set({ isLoggedIn: true, token, refreshToken });
    }
    cacheHelper.clearToken();
    cacheHelper.clearRefreshToken();
    return set({ isLoggedIn: false, token: null, refreshToken: null });
  },
}));

const useUserInfo = create((set) => ({
  userInfo: cacheHelper.getUserInfo(),
  setUserInfo: (userInfo) => {
    cacheHelper.setUserInfo(userInfo);
    return set({ userInfo });
  },
}));

const useApp = create((set) => ({
  pageTitle: '',
  setPageTitle: (title) => set({ pageTitle: title }),
  backPath: null,
  setBackPath: (title) => set({ backPath: title }),
}));

const initialUserReportState = {
  userReport: null,
  reportDetails: null,
  savingReport: false,
};

const useUserReport = create((set) => ({
  ...initialUserReportState,
  setUserReport: (userReport) => set({ userReport }),
  setReportDetails: (reportDetails) => set({ reportDetails }),
  setSavingReport: (savingReport) => set({ savingReport }),
  reset: () => set(initialUserReportState),
}));

const initialCityState = {
  openModalCities: 0, // 0 = close modal, 1 = open modal upload image, 2 = open modal change name, 3 = open modal merge city
  selectedCity: {},
  openConfirmModal: false,
  page: 1,
  fetchingCities: false,
  citiesOptionList: [],
  searchForCitiesOptionList: '',
  isFetchingCitiesOptionList: false,
  actionSuccess: false,
};
const useCity = create((set) => ({
  ...initialCityState,
  setOpenModalCities: (openModalCities) => set({ openModalCities }),
  setSelectedCity: (selectedCity) => set({ selectedCity }),
  setOpenConfirmModal: (openConfirmModal) => set({ openConfirmModal }),
  setCities: (cities) => set({ cities }),
  setFetchingCities: (fetchingCities) => set({ fetchingCities }),
  setCitiesOptionList: (citiesOptionList) => set({ citiesOptionList }),
  setSearchForCitiesOptionList: (searchForCitiesOptionList) =>
    set({ searchForCitiesOptionList }),
  setIsFetchingCitiesOptionList: (isFetchingCitiesOptionList) =>
    set({ isFetchingCitiesOptionList }),
  setActionSuccess: (actionSuccess) => set({ actionSuccess }),
  handleActionSuccess: () =>
    set((state) => ({
      actionSuccess: !state.actionSuccess,
      openModalCities: 0,
      openConfirmModal: false,
    })),
}));

const initialSpotState = {
  openModalSpots: 0, // 0 = close modal, 1 = open modal upload image, 2 = open modal change name, 3 = open modal merge city
  selectedSpot: {},
  openConfirmModal: false,
  page: 1,
  fetchingSpots: false,
  actionSuccess: false,
};
const useSpot = create((set) => ({
  ...initialSpotState,
  setOpenModalSpots: (openModalSpots) => set({ openModalSpots }),
  setSelectedSpot: (selectedSpot) => set({ selectedSpot }),
  setOpenConfirmModal: (openConfirmModal) => set({ openConfirmModal }),
  setSpots: (spots) => set({ spots }),
  setFetchingSpots: (fetchingSpots) => set({ fetchingSpots }),
  setActionSuccess: (actionSuccess) => set({ actionSuccess }),
  handleActionSuccess: () =>
    set((state) => ({
      actionSuccess: !state.actionSuccess,
      openModalSpots: 0,
      openConfirmModal: false,
    })),
}));

const initialBusiness = {
  openModalBusinessOwner: 0, // 0 = close modal, 1 = open modal upload image, 2 = open modal change name, 3 = open modal merge city
  selectedBusinessOwner: {},
  openConfirmModal: false,
  fetchingBusinessOwner: false,
  spotOptionsList: [],
  searchForSpotOptionsList: '',
  isFetchingBusinessOwnerOptionList: false,
  actionSuccess: false,
};
const useBusinessOwner = create((set) => ({
  ...initialBusiness,
  setOpenModalBusinessOwner: (openModalBusinessOwner) =>
    set({ openModalBusinessOwner }),
  setSelectedBusinessOwner: (selectedBusinessOwner) =>
    set({ selectedBusinessOwner }),
  setOpenConfirmModal: (openConfirmModal) => set({ openConfirmModal }),
  setBusinessOwner: (cities) => set({ cities }),
  setFetchingBusinessOwner: (fetchingBusinessOwner) =>
    set({ fetchingBusinessOwner }),
  setSpotOptionsList: (spotOptionsList) => set({ spotOptionsList }),
  setSearchForSpotOptionsList: (searchForSpotOptionsList) =>
    set({ searchForSpotOptionsList }),
  setIsFetchingBusinessOwnerOptionList: (isFetchingBusinessOwnerOptionList) =>
    set({ isFetchingBusinessOwnerOptionList }),
  setActionSuccess: (actionSuccess) => set({ actionSuccess }),
  handleActionSuccess: () =>
    set((state) => ({
      actionSuccess: !state.actionSuccess,
      openModalBusinessOwner: 0,
      openConfirmModal: false,
    })),
}));

const initialTagState = {
  tags: [],
};

const useTag = create((set) => ({
  ...initialTagState,
  setTags: (tags) => set({ tags }),
}));

const store = {
  useApp,
  useAuth,
  useUserInfo,
  useUserReport,
  useCity,
  useSpot,
  useBusinessOwner,
  useTag,
};

export default store;
